import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { BdDialogStackManager } from '@delen/bd-dialog';
import { BdOverlayPlaceholderComponent } from '@delen/bd-overlay-placeholder';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  template: `
    <bd-overlay-placeholder />
    <router-outlet />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterOutlet, BdOverlayPlaceholderComponent],
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly bdDialogStackManager = inject(BdDialogStackManager);

  ngOnInit(): void {
    // close dialogs and popups on navigate
    this.router.events.pipe(filter((evt) => evt instanceof NavigationEnd)).subscribe(() => {
      this.bdDialogStackManager.clear();
    });
  }
}
